<template>
  <div class="custom-mobile-overflow">
    <div v-if="person.person_institution_detail.length > 0" class="ml-3">
      <table class="table">
        <thead>
          <tr>
            <th>Name</th>
            <!-- <th>Position</th> -->
            <th>Title</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(institution, index) in person.person_institution_detail" :key="index">
            <td width="70%">
              <div class="d-flex flex-column">
                <div>
                  <div>
                    <span
                      v-if="institution.status"
                      v-b-tooltip.hover.top="getTooltipForBadge(institution.status)"
                      class="px-2 badge badge-pill regular-14 typo-color-white"
                      :class="getBadgeColor(institution.status)"
                    >
                      {{ institution.status }}
                    </span>
                    <span v-if="institution.home" class="px-2 badge badge-pill btn-primary regular-14 typo-color-white">
                      HOME
                    </span>
                    <span v-if="institution.display" class="px-2 badge badge-pill badge-secondary regular-14 typo-color-white">
                      DISPLAY
                    </span>
                  </div>
                  <a :href="fetchLegacyUrl(`/institutions/${institution.id}`)" class="regular-16" target="_blank">
                    {{ institution.name }}
                  </a>
                </div>
                <span class="regular-16">{{ institution.department }}</span>
                <span class="regular-16">{{ institution.city }},</span>
                <span class="regular-16">{{ institution.country_name }}</span>
              </div>
            </td>
            <!-- <td>
              <span class="regular-16">{{ institution.position }}</span>
            </td> -->
            <td>
              <span class="regular-16">{{ institution.person_institution_title }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <span class="text-muted regular-14">No Institutions found</span>
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js'

export default {
    name: "PersonInformation",
    mixins: [mixin],
    props: ['person'],
    methods: {
      getBadgeColor(status) {
        switch(status) {
          case 'APPROVED':
            return 'bg-success'
          case 'PENDING':
          case 'AMS':
            return 'bg-secondary'
          case 'OVERRIDDEN':
            return 'bg-info'
          default:
            return 'bg-secondary'
        }
      },
      getTooltipForBadge(status) {
        switch(status) {
          case 'APPROVED':
            return 'User Submitted institution and SLMath Verified and Approved'
          case 'PENDING':
            return 'User Submitted institution and SLMath Verified and Pending Review'
          case 'AMS':
            return 'AMS data as imported with no local SLMath changes'
          case 'OVERRIDDEN':
            return 'AMS data with local SLMath changes'
          default:
            return ''
        }
      }
    }
}
</script>
